export function normalizeArray<T>(array: T[]): Map<string, 1> {
  const map = new Map<string, 1>()
  array.forEach(item => {
    const key = String(item)
    if (key) {
      map.set(key, 1)
    }
  })
  return map
}

export function normalizeArrayWithCustomValue<T, P>(
  array: T[],
  getValue: (item: T, index: number) => P,
): Map<string, P> {
  const map = new Map<string, P>()
  array.forEach((item, index) => {
    const key = String(item)
    if (key) {
      map.set(key, getValue(item, index))
    }
  })
  return map
}
